import * as React from "react";

import { ControlReference } from "../../Engine/Core/ControlDispatcher/ControlReference";
import { ITourElementsRegistry } from "../../Controls/Internals/TourManagement/ITourElementsRegistry";
import { useTourElementsRegistry } from "../../Controls/Internals/TourManagement/TourElementsRegistryContext";

interface ICustomControlControlDispatcher {
    registerControl(id: string, control: ControlReference): void;
    unregisterControl(id: string, control: undefined | null | ControlReference): void;
}

class TourElementsRegistryAsDispatcherWrapper implements ICustomControlControlDispatcher {
    readonly #tourElementsRegistry: ITourElementsRegistry;

    public constructor(tourElementsRegistry: ITourElementsRegistry) {
        this.#tourElementsRegistry = tourElementsRegistry;
    }

    public registerControl(id: string, control: ControlReference): void {
        this.#tourElementsRegistry.registerControl(id, control);
    }

    public unregisterControl(id: string, control: ControlReference | undefined | null): void {
        this.#tourElementsRegistry.unregisterControl(id, control ?? undefined);
    }
}

export function withControlDispatcher<T>(
    Component: React.ComponentType<T & { controlDispatcher: ICustomControlControlDispatcher }>
): React.ComponentType<T> {
    return function WithModelAccessorWrapper(props: T): JSX.Element {
        const tourElementsRegistry = useTourElementsRegistry();
        if (tourElementsRegistry == undefined) {
            throw new Error("tourElementsRegistry must be provided");
        }
        const tourElementsRegistryAsDispatcherWrapper = React.useMemo(
            () => new TourElementsRegistryAsDispatcherWrapper(tourElementsRegistry),
            [tourElementsRegistry]
        );
        return <Component {...props} controlDispatcher={tourElementsRegistryAsDispatcherWrapper} />;
    };
}
